module.exports = __webpack_public_path__ + "static/media/1Asset-29-100.12dc2667.jpg";